import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ORG_ID, GOOGLE_CLIENT_ID } from 'config';
import Role from 'constants/role';
import dataProvider from 'data-provider';
import OrgProvider from 'OrgProvider';
import React from 'react';
import { Admin, CustomRoutes } from 'react-admin';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Route } from 'react-router-dom';
import { theme } from 'theme';
import { rolesMatch } from 'utils/user';
import { renderActivitiesResource } from 'views/activities';
import { renderChannelResource } from 'views/channel';
import { renderIncomeResource } from 'views/income';
import { renderOrganizationResource } from 'views/organization';
import { renderTransactionResource } from 'views/Transaction';
import { renderUserResource } from 'views/user';
import Contract from 'views/user/Contract/Contract';
import ContractTether from 'views/user/Contract/ContractTether';
import { renderVideoResource } from 'views/video';
import { renderTokenResource } from 'views/token';
import OAuthCallbackHandler from 'components/OAuthCallbackHandler';
import SendSms from 'views/SendSms';
import { MyLayout } from './MyLayout';
import authProvider from './authProvider';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <OAuthCallbackHandler />
        <OrgProvider>
          <Admin
            authProvider={authProvider}
            dataProvider={dataProvider}
            theme={theme}
            layout={MyLayout}
          >
            {(roles) => (
              <>
                {!ORG_ID && rolesMatch({ roles, role: Role.SUPER_ADMIN }) && renderOrganizationResource(roles)}
                {rolesMatch({ roles, role: Role.CHANNEL_VIEW }) && renderChannelResource(roles)}
                {rolesMatch({ roles, role: Role.USER_VIEW }) && renderUserResource(roles)}
                {rolesMatch({ roles, role: Role.WALLET_TRANSACTION_VIEW }) && renderTransactionResource(roles)}
                {rolesMatch({ roles, role: Role.VIDEO_VIEW }) && renderVideoResource(roles)}
                {rolesMatch({ roles, role: Role.INCOME_VIEW }) && renderIncomeResource(roles)}
                {rolesMatch({ roles, role: Role.ORG_SUPER_ADMIN }) && renderActivitiesResource(roles)}
                {rolesMatch({ roles, role: Role.SUPER_ADMIN }) && renderTokenResource(roles)}
                <CustomRoutes>
                  {rolesMatch({ roles, role: Role.USER_VIEW }) && <Route path="/user-contract/tether" element={<ContractTether />} />}
                  {rolesMatch({ roles, role: Role.USER_VIEW }) && <Route path="/user-contract" element={<Contract />} />}
                  {rolesMatch({ roles, role: Role.SEND_SMS }) && <Route path="/send-sms" element={<SendSms />} />}
                </CustomRoutes>
              </>
            )}
          </Admin>
        </OrgProvider>
      </GoogleOAuthProvider>
    </LocalizationProvider>
  );
}

export default App;
